module.exports = __webpack_public_path__ + "media/images/patient-icon-nav-85056de39e1417c5edfbada6214747d3.svg";